import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { QUERY_KEY } from '@/modules/deductibles/SpendTracker/queries/useDeductibles.query.ts';

interface IndividualDeductible {
  employee_id: number;
  dependent_id?: number;
  deductibles_amount: number;
  effective_date: string;
}

interface UpdatePayload {
  health_policy_id: number;
  family_deductible_amount: number;
  effective_date: string;
  individual_deductibles?: IndividualDeductible[];
}

export const useUpdateDeductibleQuery = (id?: string) => {
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading, isSuccess } = useMutation(
    async (payload: UpdatePayload) =>
      api.put(API_URL.DEDUCTIBLES_EMPLOYEES_BY_EMPLOYEE_ID(id || ''), payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEY],
        });
      },
    }
  );

  return {
    updateDeductibles: mutateAsync,
    isLoading,
    isSuccess,
  };
};
